import {
  BaseQueryFn,
  FetchArgs,
  fetchBaseQuery,
  FetchBaseQueryError,
} from '@reduxjs/toolkit/query';
import { RootState } from 'app/redux';
import { environment } from 'environment';
import { authSlice, AuthState } from 'features/auth/authSlice';
import { handleExpiredSession } from './utils/handleExpiredSession';
import { customStatusCodes } from './utils/customStatusCodes';

const baseQuery = fetchBaseQuery({
  baseUrl: environment.apiRoute,
  prepareHeaders: (headers: Headers, { getState }) => {
    const state = getState() as RootState;
    const { token } = state.auth;

    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    }

    return headers;
  },
});

export const customBaseQuery: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  const { dispatch, endpoint, getState } = api;
  const { auth } = getState() as { auth: AuthState };
  const { removeEndpointToRefetch } = authSlice.actions;

  const result = await baseQuery(args, api, extraOptions);
  const { error, meta } = result;

  if (meta?.response) {
    const { response } = meta;

    if (response.ok && auth.endpointsToRefetch.includes(endpoint)) {
      dispatch(removeEndpointToRefetch(endpoint));
    }

    if (!response.ok && error?.status === customStatusCodes.SESSION_EXPIRED) {
      handleExpiredSession(api, result);
    }
  }

  return result;
};
